// Document security API: purge (delete original) per-document and per-case.
//
// Purging removes the original file bytes from disk but keeps the metadata
// row for the audit trail. After purge, download/view is disabled.
import apiClient from './client';

export interface PurgeResult {
  document_id?: string;
  case_id?: string;
  purged: boolean;
  already_purged?: boolean;
  purged_count?: number;
}

/** Purge a single document's original file bytes (compliance/operator only). */
export async function purgeDocument(documentId: string): Promise<PurgeResult> {
  const { data } = await apiClient.delete<PurgeResult>(`/documents/${documentId}`);
  return data;
}

/** Purge ALL original documents for a case at once (compliance/operator only). */
export async function purgeCaseDocuments(caseId: string): Promise<PurgeResult> {
  const { data } = await apiClient.delete<PurgeResult>(
    `/cases/${caseId}/documents`
  );
  return data;
}